/* eslint-disable */
import { PluginContainerData } from './common.js';

import { CollapsibleListData_InitialExpandedItems, CollapsibleListData_Direction } from './plugin_collapsible_list.enums.js';

export interface CollapsibleListData {
  /** Styling for the collapsible list's container. */
  containerData?: PluginContainerData;
  /** If `true`, only one item can be expanded at a time. Defaults to `false`. */
  expandOnlyOne?: boolean;
  /** Sets which items are expanded when the page loads. */
  initialExpandedItems: CollapsibleListData_InitialExpandedItems;
  /** The direction of the text in the list. Either left-to-right or right-to-left. */
  direction: CollapsibleListData_Direction;
  /** If `true`, The collapsible item will appear in search results as an FAQ. */
  isQapageData?: boolean;
}

export function collapsibleListData_InitialExpandedItemsFromJSON(
  object: any
): CollapsibleListData_InitialExpandedItems {
  switch (object) {
    case 0:
    case 'FIRST':
      return CollapsibleListData_InitialExpandedItems.FIRST;
    case 1:
    case 'ALL':
      return CollapsibleListData_InitialExpandedItems.ALL;
    case 2:
    case 'NONE':
      return CollapsibleListData_InitialExpandedItems.NONE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CollapsibleListData_InitialExpandedItems.UNRECOGNIZED;
  }
}

export function collapsibleListData_InitialExpandedItemsToJSON(
  object: CollapsibleListData_InitialExpandedItems
): string {
  switch (object) {
    case CollapsibleListData_InitialExpandedItems.FIRST:
      return 'FIRST';
    case CollapsibleListData_InitialExpandedItems.ALL:
      return 'ALL';
    case CollapsibleListData_InitialExpandedItems.NONE:
      return 'NONE';
    default:
      return 'UNKNOWN';
  }
}

export function collapsibleListData_DirectionFromJSON(object: any): CollapsibleListData_Direction {
  switch (object) {
    case 0:
    case 'LTR':
      return CollapsibleListData_Direction.LTR;
    case 1:
    case 'RTL':
      return CollapsibleListData_Direction.RTL;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CollapsibleListData_Direction.UNRECOGNIZED;
  }
}

export function collapsibleListData_DirectionToJSON(object: CollapsibleListData_Direction): string {
  switch (object) {
    case CollapsibleListData_Direction.LTR:
      return 'LTR';
    case CollapsibleListData_Direction.RTL:
      return 'RTL';
    default:
      return 'UNKNOWN';
  }
}

const baseCollapsibleListData: object = {
  initialExpandedItems: CollapsibleListData_InitialExpandedItems.FIRST,
  direction: CollapsibleListData_Direction.LTR,
};

export const CollapsibleListData = {
  fromJSON(object: any): CollapsibleListData {
    const message = { ...baseCollapsibleListData } as CollapsibleListData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.expandOnlyOne =
      object.expandOnlyOne !== undefined && object.expandOnlyOne !== null
        ? Boolean(object.expandOnlyOne)
        : undefined;
    message.initialExpandedItems =
      object.initialExpandedItems !== undefined && object.initialExpandedItems !== null
        ? collapsibleListData_InitialExpandedItemsFromJSON(object.initialExpandedItems)
        : CollapsibleListData_InitialExpandedItems.FIRST;
    message.direction =
      object.direction !== undefined && object.direction !== null
        ? collapsibleListData_DirectionFromJSON(object.direction)
        : CollapsibleListData_Direction.LTR;
    message.isQapageData =
      object.isQapageData !== undefined && object.isQapageData !== null
        ? Boolean(object.isQapageData)
        : undefined;
    return message;
  },

  toJSON(message: CollapsibleListData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.expandOnlyOne !== undefined && (obj.expandOnlyOne = message.expandOnlyOne);
    message.initialExpandedItems !== undefined &&
      (obj.initialExpandedItems = collapsibleListData_InitialExpandedItemsToJSON(
        message.initialExpandedItems
      ));
    message.direction !== undefined &&
      (obj.direction = collapsibleListData_DirectionToJSON(message.direction));
    message.isQapageData !== undefined && (obj.isQapageData = message.isQapageData);
    return obj;
  },
};
